module.exports = __webpack_public_path__ + "static/diy-logo-e407e27d81846ed8bc511305f1cabf35.png";